// extracted by mini-css-extract-plugin
export default {"wrapper":"View_wrapper__kSUDd","title":"View_title__AzvjR"};